import "@splidejs/splide/dist/css/splide-core.min.css";
import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

/* トップページ トピックス  スライドで切り替え */
document.addEventListener('DOMContentLoaded', function () {
  var slider = document.querySelector('#js-topics-splide');
  if (!slider) return; // 投稿がないときはJS動かさない

  var splide = new Splide(slider, {
    type: 'loop',
    autoplay: true,
    interval: 4000,
    speed: 1000,
    pauseOnHover: true,
    pauseOnFocus: true,
    arrows: true,
    pagination: false,
    perPage: 3,
    perMove: 1,
    gap: '20px',
    breakpoints: {
      767: {
        perPage: 1
      }
    }
  });

  splide.mount();

  var nextBtn = document.querySelector('.p-top-topics .splide__arrow--next');
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      splide.go('+1');
    });
  }

  var prevBtn = document.querySelector('.p-top-topics .splide__arrow--prev');
  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      splide.go('-1');
    });
  }
});



/* トップページ 症例写真  スライドで切り替え */
document.addEventListener('DOMContentLoaded', () => {
  const caseSplideElement = document.querySelector('#js-case-splide');
  if (!caseSplideElement) return;

  const caseSplideInstance = new Splide(caseSplideElement, {
    type: 'loop',
    autoWidth: true,
    autoplay: false,
    interval: 4000,
    speed: 1000,
    pauseOnHover: true,
    pauseOnFocus: true,
    arrows: true,
    pagination: false,
    perMove: 1,
    gap: 'calc(34 / 16 * 1rem)',
    padding: {
      right: '14%',
    },
    breakpoints: {
      767: {
        gap: 0,
        padding: { left: 0, right: 0 },
      },
    },
  });

  
  /* スライド枚数が不足する場合の処理 */
  let lastIsOverflow = null;

  caseSplideInstance.on('overflow', function (isOverflow) {
    if (lastIsOverflow !== null && lastIsOverflow !== isOverflow) {
      caseSplideInstance.go(0);
    }
    lastIsOverflow = isOverflow;

    caseSplideInstance.options = {
      ...caseSplideInstance.options,
      type: isOverflow ? 'loop' : 'slide',
      arrows: isOverflow,
      pagination: isOverflow,
      drag: isOverflow,
      clones: isOverflow ? undefined : 0,
      autoplay: isOverflow,
    };

    if (caseSplideInstance.Components && caseSplideInstance.Components.Autoplay) {
      if (isOverflow) {
        caseSplideInstance.Components.Autoplay.play();
      } else {
        caseSplideInstance.Components.Autoplay.pause();
      }
    }
  });

  caseSplideInstance.mount();

  // 画像読み込み後にサイズが確定するため、再評価
  window.addEventListener('load', () => {
    caseSplideInstance.refresh();
  });
});


/* ギャラリー スライダー */
document.addEventListener("DOMContentLoaded", function () {
  const main = document.querySelector("#js-gallery-main");
  const thumb = document.querySelector("#js-gallery-thumb");
  if (!main || !thumb) return;

  // メインスライダー
  const mainSlider = new Splide(main, {
    type: "fade",
    rewind: true,
    pagination: false,
    arrows: false,
    speed: 1000,
    pauseOnHover: false,
    pauseOnFocus: false,
  });

  // サムネイルスライダー（ループさせる）
  const thumbSlider = new Splide(thumb, {
    type: "loop",
    perPage: 4,
    gap: "1.375rem",
    pagination: false,
    arrows: true,
    isNavigation: true,
    autoplay: true,
    interval: 4000,
    updateOnMove: true, // is-activeクラスを移動前に更新
    breakpoints: {
      768: {
        perPage: 2,
        focus: "center", 
        gap: "0.5rem",
      },
    },
  });

  mainSlider.sync(thumbSlider);
  mainSlider.mount();
  thumbSlider.mount();
});